import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22.65}
      height={20.141}
      viewBox="0 0 22.65 20.141"
      {...props}
    >
      <g data-name="Group 317">
        <path
          data-name="Path 7361"
          d="M8.323 8.434h-.111V6.775a.332.332 0 00-.566-.235l-.442.442a.332.332 0 00.345.547v.9h-.111a.332.332 0 100 .663h.885a.332.332 0 100-.663z"
        />
        <path
          data-name="Path 7362"
          d="M10.031 6.443a1 1 0 00-1 1v.663a1 1 0 101.99 0v-.671a1 1 0 00-.99-.992zm.332 1.659a.332.332 0 11-.663 0v-.667a.332.332 0 01.663 0z"
        />
        <path
          data-name="Path 7363"
          d="M12.399 6.443a1 1 0 00-1 1v.663a1 1 0 101.99 0v-.671a1 1 0 00-.99-.992zm.332 1.659a.332.332 0 11-.663 0v-.667a.332.332 0 01.663 0z"
        />
        <path
          data-name="Path 7364"
          d="M14.106 7.107a.332.332 0 10-.332-.332.332.332 0 00.332.332z"
        />
        <path
          data-name="Path 7365"
          d="M15.372 6.485a.332.332 0 00-.451.129l-1.106 1.99a.332.332 0 10.58.322l1.106-1.99a.332.332 0 00-.129-.451z"
        />
        <path
          data-name="Path 7366"
          d="M15.212 8.433a.332.332 0 10.332.332.332.332 0 00-.332-.332z"
        />
        <path
          data-name="Path 7367"
          d="M.332 11.066a.332.332 0 00.332-.332.332.332 0 01.336-.331h20.654a.332.332 0 01.332.332.332.332 0 00.664 0 1 1 0 00-1-1h-.319a.96.96 0 00-.262-.386l-1.122-1 .655-1.352a.961.961 0 00-.549-1.325l-1.419-.493.087-1.5a.961.961 0 00-1.014-1.014l-1.5.087-.489-1.412a.961.961 0 00-1.325-.549l-1.352.655-1-1.122a.96.96 0 00-1.435 0l-1 1.122L8.257.79a.961.961 0 00-1.325.549l-.493 1.419-1.5-.087a.961.961 0 00-1.014 1.014l.087 1.5-1.419.493a.961.961 0 00-.549 1.325L2.7 8.355l-1.122 1a.961.961 0 00-.262.386H1a1 1 0 00-1 1 .332.332 0 00.332.332zm3-2.382a.332.332 0 00.078-.392l-.764-1.578a.3.3 0 01.17-.41l1.656-.576a.332.332 0 00.222-.333l-.1-1.75a.3.3 0 01.313-.313l1.75.1a.332.332 0 00.333-.222l.576-1.656a.3.3 0 01.41-.17l1.578.764a.332.332 0 00.392-.078L11.1.763a.3.3 0 01.443 0l1.165 1.309a.332.332 0 00.392.078l1.578-.764a.3.3 0 01.41.17l.576 1.656a.332.332 0 00.333.222l1.75-.1a.3.3 0 01.313.313l-.1 1.75a.332.332 0 00.222.333l1.656.576a.3.3 0 01.17.41l-.764 1.578a.332.332 0 00.078.392l1.187 1.054H5.352a5.987 5.987 0 015.973-5.65 6.009 6.009 0 015.849 4.734.333.333 0 00.324.263.307.307 0 00.069-.008.332.332 0 00.255-.393A6.646 6.646 0 004.687 9.74H2.141z"
        />
        <path
          data-name="Path 7368"
          d="M22.318 13.054a.332.332 0 00-.332.332.332.332 0 01-.332.332H1a.332.332 0 01-.332-.332.332.332 0 10-.664 0 1 1 0 001 1h2.542l.472.472-.093 1.6a.961.961 0 001.014 1.014l1.5-.087.493 1.419a.961.961 0 001.325.549l1.352-.655 1 1.122a.961.961 0 001.435 0l1-1.122 1.352.655a.961.961 0 001.325-.549l.493-1.419 1.5.087a.961.961 0 001.014-1.014l-.093-1.6.472-.472h2.551a1 1 0 001-1 .332.332 0 00-.34-.332zm-4.357 1.689l.1 1.75a.3.3 0 01-.313.313l-1.75-.1a.332.332 0 00-.333.222l-.576 1.656a.3.3 0 01-.41.17l-1.578-.764a.332.332 0 00-.392.078l-1.165 1.309a.3.3 0 01-.443 0l-1.165-1.309a.332.332 0 00-.392-.078l-1.578.764a.3.3 0 01-.41-.17l-.576-1.656a.331.331 0 00-.333-.222l-1.75.1a.3.3 0 01-.313-.313l.1-1.75a.332.332 0 00-.1-.254l-.108-.108h10.989a5.97 5.97 0 01-7.89.345.332.332 0 10-.417.516 6.615 6.615 0 004.165 1.471 6.632 6.632 0 005.051-2.333h1.789l-.108.108a.332.332 0 00-.094.257z"
        />
        <path
          data-name="Path 7369"
          d="M1.94 11.397h.243a.332.332 0 100-.663H1.94a1.327 1.327 0 101.327 1.327.332.332 0 00-.332-.332H2.36a.332.332 0 100 .663h.154a.664.664 0 11-.575-1z"
        />
        <path
          data-name="Path 7370"
          d="M3.864 10.734a.332.332 0 00-.332.332v1.2a1.128 1.128 0 002.256 0v-1.2a.332.332 0 00-.663 0v1.2a.465.465 0 01-.929 0v-1.2a.332.332 0 00-.332-.332z"
        />
        <path
          data-name="Path 7371"
          d="M7.027 10.734a.332.332 0 00-.311.215l-.746 1.99a.332.332 0 10.621.233l.044-.116h.784l.044.116a.332.332 0 10.621-.233l-.746-1.99a.332.332 0 00-.311-.215zm-.143 1.659l.143-.382.143.382z"
        />
        <path
          data-name="Path 7372"
          d="M10.449 11.727a.994.994 0 00-.99-1h-.647a.332.332 0 00-.332.332v1.991a.332.332 0 00.664 0v-.323h.177l.561.565a.332.332 0 00.471-.467l-.3-.3a1 1 0 00.396-.798zm-.99.332h-.315v-.663h.315a.332.332 0 010 .663z"
        />
        <path
          data-name="Path 7373"
          d="M11.859 10.734a.332.332 0 00-.311.215l-.746 1.99a.332.332 0 10.621.233l.044-.116h.784l.044.116a.332.332 0 10.621-.233l-.746-1.99a.332.332 0 00-.311-.215zm-.143 1.659l.143-.382.143.382z"
        />
        <path
          data-name="Path 7374"
          d="M14.724 11.066v.977l-.86-1.173a.332.332 0 00-.6.2v1.99a.332.332 0 00.664 0v-.977l.86 1.173a.332.332 0 00.6-.2v-1.991a.332.332 0 00-.664 0z"
        />
        <path
          data-name="Path 7375"
          d="M16.668 13.388a.332.332 0 00.332-.332v-1.659h.42a.332.332 0 000-.663h-1.5a.332.332 0 100 .663h.42v1.659a.332.332 0 00.328.332z"
        />
        <path
          data-name="Path 7376"
          d="M19.292 11.397a.332.332 0 000-.663h-1.017a.332.332 0 00-.332.332v1.991a.332.332 0 00.332.332h1.017a.332.332 0 000-.663h-.686v-.332h.42a.332.332 0 000-.663h-.42v-.332z"
        />
        <path
          data-name="Path 7377"
          d="M21.356 11.397a.332.332 0 100-.663h-1.017a.332.332 0 00-.332.332v1.991a.332.332 0 00.332.332h1.017a.332.332 0 100-.663h-.686v-.332h.42a.332.332 0 000-.663h-.42v-.332z"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
